export default __webpack_public_path__ + "static/media/progress-upload.e563c978.svg";